<template>
  <div>
    <el-dialog
      :title="$t('basicData.DiscountCoefficientDetails')"
      :visible.sync="dialogTableVisible"
      append-to-body
      width="1052px"
    >
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-plus"
        class="mb10"
        @click="Add"
      >{{ $t('GlobalSetObj.add') }}
      </el-button>
      <el-button
        size="mini"
        icon="el-icon-bottom"
        class="mb10"
        @click="exportData"
      >{{ $t('receivablePayable.Export') }}
      </el-button>

      <el-table
        :data="gridData" border size="small"
        :height="350"
      >
        <el-table-column property="startTime" :label="$t('basicData.ValidityStart')" width="180" />
        <el-table-column property="endTime" :label="$t('basicData.ValidityEnd')" width="180" />
        <el-table-column property="discountRate" :label="$t('basicData.DiscountRate')" width="150" />
        <el-table-column property="offerPriceDiscountStatusAlias" :label="$t('basicData.EffectiveStatus')" width="150" />
        <el-table-column property="updateUsername" :label="$t('basicData.Operator')" width="200" />
        <el-table-column
          :label="$t('basicData.operate')" align="center"
          width="160"
        >
          <template slot-scope="scope">
            <div class="feet-r">
              <el-button
                v-if="scope.row.offerPriceDiscountStatus === 2"
                class="ml" type="primary"
                size="mini"
                @click="updateStats(scope.row, 2)"
              >{{ $t('dictionary.modify') }}</el-button>
              <!--            删除-->
              <el-popconfirm
                :title="$t('basicData.AreYouSureDelete')"
                @confirm="Del(scope.row, 0)"
              >
                <el-button
                  v-if="scope.row.offerPriceDiscountStatus === 2"
                  slot="reference" class="ml" type="danger"
                  size="mini"
                >{{ $t('basicData.Delete') }}</el-button>
              </el-popconfirm>
              <!--确定禁用吗？-->
              <el-popconfirm
                :title="$t('basicData.AreYouSureDisabled')"
                @confirm="updateStats(scope.row, 3)"
              >
                <!--禁用-->
                <el-button
                  v-if="scope.row.offerPriceDiscountStatus === 1"
                  slot="reference" class="ml"
                  type="danger"
                  size="mini"
                >{{ $t('basicData.disable') }}</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :current-page="paramsForm.pageNumber"
          :page-size="paramsForm.pageSize"
          :total="total"
          :page-sizes="[10, 50, 100]"
          background
          style="margin: 10px 0"
          @current-change="currentPage"
          @size-change="currentSize"
        />
      </div>
    </el-dialog>

    <el-dialog
      :title="type === 1 ? $t('GlobalSetObj.add') : $t('dictionary.modify')"
      :visible.sync="visibleForm"
      append-to-body
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        ref="form" :model="form" label-position="top"
        size="small"
      >
        <el-form-item
          :label="$t('basicData.DiscountRate')"
          prop="discountRate"
          :rules="[
            {
              required: true,
              message: $t('basicData.CannotBeEmpty'),
              trigger: ['blur', 'change']
            }
          ]"
        >
          <el-input-number
            v-model="form.discountRate" :min="0.1" :max="1"
            :placeholder="$t('basicData.PleaseEnterADecimal')"
            :precision="2"
            :controls="false"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item
          :label="$t('basicData.ValidityStart')"
          prop="startTime"
          :rules="[
            { required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
          ]"
        >
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            :format="isZh"
            :picker-options="pickerOptions"
            :placeholder="$t('basicData.SelectDate')"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="close"
        >{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="saveForm"
        >{{ $t('basicData.Save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  offerPriceDiscountPage,
  offerPriceDiscountAdd,
  offerPriceDiscountEdit,
  offerPriceDiscountDelete,
  offerPriceDiscountExport,
  offerPriceDiscountDisable
} from '@/api/finance/basicData';
import { goExportList } from '@/utils/goExportList';
export default {
  name: 'DiscountDiaLog',
  props: {
    ids: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      visibleForm: false,
      type: 1,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      paramsForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          offerPriceIdList: []
        }
      },
      form: {
        startTime: '',
        discountRate: null
      },
      gridData: [],
      total: 0
    };
  },
  computed: {
    // 1 账单日期语言
    isZh() {
      return this.$i18n.locale === 'zh' ? this.zhDate : this.ptDate;
    },
    // 2 账单日期限制
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 3600 * 1000; // 不能选择生效日期在当前服务时间之前
        }
      };
    }
  },
  watch: {
    dialogTableVisible: {
      handler(val) {
        if (val) {
          if (this.ids.length > 0) {
            this.getPageList();
          }
        }
      }
    }
  },
  methods: {
    open() {
      this.dialogTableVisible = true;
    },
    Add() {
      this.type = 1;
      this.form = {
        startTime: '',
        discountRate: 0
      };
      this.visibleForm = true;
      this.$refs.form.resetFields();
    },
    // 2 修改 3 禁用
    updateStats(row, num) {
      if (num === 2) {
        this.type = 2;
        this.visibleForm = true;
        this.form = row;
      } else {
        this.updateDisable(row.idList);
      }
    },
    // 关闭
    close() {
      this.visibleForm = false;
    },
    currentPage(val) {
      this.paramsForm.pageNumber = val;
      this.getPageList();
    },
    currentSize(val) {
      this.paramsForm.pageNumber = 1;
      this.paramsForm.pageSize = val;
      this.getPageList();
    },
    // 列表
    getPageList() {
      this.paramsForm.params.offerPriceIdList = this.ids;
      offerPriceDiscountPage(this.paramsForm).then(res => {
        if (res.code === 200) {
          this.gridData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 删除
    Del(row, num) {
      console.log(row, num);
      offerPriceDiscountDelete(row.idList).then(res => {
        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
        this.getPageList();
      });
    },
    // 禁用
    updateDisable(data) {
      offerPriceDiscountDisable(data).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.getPageList();
        }
      });
    },
    // 导出
    exportData() {
      offerPriceDiscountExport({ offerPriceIdList: this.ids }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          goExportList(this).then(res => {
            if (res) {
              this.dialogTableVisible = false;
            }
          });
        }
      });
    },
    // 保存
    saveForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const API = this.type === 1 ? offerPriceDiscountAdd : offerPriceDiscountEdit;
        this.form.offerPriceIdList = this.ids;
        API(this.form).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded'));
            this.visibleForm = false;
            this.getPageList();
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>
